// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_bridges_src_app_app_module_ts":"2cf65a5556126505","projects_bridges_src_app_features_admin_admin_module_ts":"7eab61451bb9da55","projects_bridges_src_app_features_microsoft-teams_teams_component_ts":"c3d3715a4f98553d"}[chunkId] + ".js";
};